import { gunzipSync } from "zlib";
import { LottieParser } from "./LottieParser";
import { Buffer } from "buffer";
export const isGzip = (buf) => (!buf || buf.length < 3)
    ? false
    : buf[0] === 0x1F && buf[1] === 0x8B && buf[2] === 0x08;
export const lottieResizer = async (buffer, width, height) => {
    const rawJson = Buffer.isBuffer(buffer)
        ? Buffer.isBuffer(buffer) && isGzip(buffer)
            ? JSON.parse(gunzipSync(buffer).toString("utf-8"))
            : JSON.parse(buffer.toString("utf-8"))
        : buffer;
    console.log(rawJson);
    const parser = new LottieParser(rawJson);
    await parser.setSize(width, height).catch(err => {
        console.error("===Modification Error===");
        console.error("There was an error converting this sticker :(\nPerhaps try converting to APNG instead?");
        console.error(err);
    });
    const newLottie = parser.json;
    return newLottie;
};
